<template lang="pug">

    Hello

</template>

<script>

export default {
    name: 'Home',

    components: {
    }
};

</script>
